import { Navigate } from 'react-router-dom';
import Loader from './Loader';
import { useSupabaseAuth } from '../context/AuthContext';
import ProtectedRoute from './ProtectedRoute';

/**
 * Gates the platform console (/platform) to Transformax staff only.
 * profiles.is_platform_staff is a real, explicit flag — set for Transformax team accounts,
 * not inferred from which organisation a profile happens to belong to.
 */
export default function StaffRoute({ children }) {
  return (
    <ProtectedRoute>
      <StaffCheck>{children}</StaffCheck>
    </ProtectedRoute>
  );
}

function StaffCheck({ children }) {
  const { loading, profile } = useSupabaseAuth();

  if (loading) return <Loader text="Checking access..." />;
  if (!profile?.is_platform_staff) return <Navigate to="/app" replace />;

  return children;
}
